export var StateMap;
(function (StateMap) {
    StateMap["sid"] = "sid";
    StateMap["profile_keyword"] = "profile_keyword";
    StateMap["language"] = "language";
    StateMap["user_application"] = "user_application";
    StateMap["configuration"] = "configuration";
    StateMap["last_sid"] = "last_sid";
    StateMap["device"] = "device";
    StateMap["application_build"] = "application_build";
    StateMap["react_build"] = "react_build";
})(StateMap || (StateMap = {}));
